<mat-form-field appearance="outline" class="w-3/4 !-mb-[1.25em]">
    <mat-select [formControl]="form.controls.workflowState" panelWidth="w-full">
        @for (
            workflowState of workflowStateDropdownOptions;
            track workflowState.value
        ) {
            <mat-option
                [value]="workflowState.value"
                [disabled]="workflowState.disabled"
            >
                {{ workflowState.label }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
